<!-- src/App.vue -->
<template>
  <div style="width: 99vw; height: 97.5vh;">
    <RouterView></RouterView>
  </div>
</template>

<script>
import { RouterView } from 'vue-router';
export default {
  name: 'MarkdownEditorApp',
  components: {
    RouterView
  },
}
</script>

<style>

</style>
